/**
 * Email cím megerősítés feature szövegei
 *
 * Namespace: verifyEmail
 */
export const verifyEmail = {
  // Oldal
  page: {
    title: "Email cím megerősítése",
    subtitle: "Kérjük, várj, amíg megerősítjük az email címed",
  },

  // Sikeres megerősítés
  success: {
    title: "Email cím megerősítve!",
    message: "Az email címed sikeresen megerősítésre került. Most már bejelentkezhetsz a fiókodba.",
    goToLogin: "Tovább a bejelentkezéshez",
  },

  // Hibák
  errors: {
    invalidToken: "Az email megerősítő link érvénytelen vagy lejárt.",
  },

  // Processing state
  processing: {
    title: "Email cím megerősítése...",
    subtitle: "Kérjük, várj egy pillanatot",
  },
} as const;

export type VerifyEmailMessages = typeof verifyEmail;
